var render, staticRenderFns
import script from "./loginVerify.vue?vue&type=script&lang=ts"
export * from "./loginVerify.vue?vue&type=script&lang=ts"
import style0 from "./loginVerify.scss?vue&type=style&index=0&id=49c1bcba&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c1bcba",
  null
  
)

export default component.exports